/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_InteriorInputs */

const en_landing_showcase_interior = /** @type {(inputs: Landing_Showcase_InteriorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interior`)
};

const zh_landing_showcase_interior = /** @type {(inputs: Landing_Showcase_InteriorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内空间`)
};

/**
* | output |
* | --- |
* | "Interior" |
*
* @param {Landing_Showcase_InteriorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_interior = /** @type {((inputs?: Landing_Showcase_InteriorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_InteriorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_interior(inputs)
	return zh_landing_showcase_interior(inputs)
});
export { landing_showcase_interior as "landing.showcase.interior" }